import React, { useCallback, useEffect, useReducer } from "react";

import Table from "./partials/Table";
import FilterForm from "./partials/FilterForm";
import Summary from "./partials/Summary";
import { useCookies } from "react-cookie";
import { getListMoneyLog } from "../../../controller/api/moneyLog";
import { calculatePage } from "../../../helper/helper";

export const Context = React.createContext(null);

const initialData = {
  filter: {
    from: new Date(),
    to: new Date(),
    phone: '',
    wallet: '',
    page: 0
  },
  data: {
    list: [],
    total: 0,
    totalPage: 0
  },
  loading: false,
  filterPressCount: 0,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SUBMIT_FILTER':
      return {
        ...state,
        filter: {
          ...action.payload,
          page: 0
        },
        filterPressCount: state.filterPressCount + 1
      }
    case 'UPDATE_DATA':
      return {
        ...state,
        data: {
          ...action.payload
        }
      }
    case 'SET_LOADING':
      return {
        ...state,
        loading: action.payload
      }
    case 'UPDATE_PAGE':
      return {
        ...state,
        filter: {
          ...state.filter,
          page: action.payload
        }
      }
    default:
      return {
        ...state
      }
  }
}

const _TransactionHistory = () => {

  var [state, dispatch] = useReducer(reducer, initialData);

  const [cookies] = useCookies(['lottmekong'])

  const getAllFunc = useCallback(async () => {
    dispatch({ type: 'SET_LOADING', payload: true })

    try {
      const response = await getListMoneyLog(cookies.lottmekong, {
        from: state.filter.from,
        to: state.filter.to,
        phone: state.filter.phone,
        wallet: state.filter.wallet
      }, state.filter.page)

      if (response) {
        dispatch({
          type: 'UPDATE_DATA',
          payload: {
            list: response.data,
            total: response.total,
            totalPage: calculatePage(response.total)
          }
        })
      }
    } finally {
      dispatch({ type: 'SET_LOADING', payload: false })
    }
  }, [cookies.lottmekong, state.filter.from, state.filter.to, state.filter.phone, state.filter.wallet, state.filter.page])

  useEffect(() => {
    getAllFunc()
  }, [getAllFunc, state.filterPressCount, state.filter.page])

  useEffect(() => {
    document.title = "Lịch sử giao dịch"
  }, []);

  return (
    <Context.Provider value={{
      state,
      dispatch
    }}>

      <FilterForm />

      <br />

      <Summary />

      <br />

      <Table />
    </Context.Provider>
  );
};

export default _TransactionHistory;
